import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import Notifications from '../components/Notifications';
import Layout from '../components/Layout';
import { useTour } from '../provider/TourGuide';
import { NotificationPage as Tour } from '../enums/tourEnums';
import introJs from 'intro.js';

const NotificationsPage = () => {
    const {SaveRead, onExitNotification, setEnabledNotification} = useTour()
  
    useEffect(() => {
      if(!localStorage.getItem("notification")){
        const intro = introJs()
          .onstart(() => setEnabledNotification(true))
          .oncomplete(() => onExitNotification())
          .onexit(() => onExitNotification());
          intro.setOptions({
                ...Tour,
                scrollToElement: false,     
                disableInteraction: true,  
            });
        intro.start();
      }
    },[SaveRead])

    return (
        <Layout widhoutPadding={false}>
            <Notifications.List/>
        </Layout>
    );
};

export default NotificationsPage;